import React from "react";
import { Box, Stack, Collapse } from "@mui/material";
import StatusDropdown from "./StatusDropdown";
import DateInput from "./DateInput";

const OrderFilters = ({
  statusFilter,
  setStatusFilter,
  dateRange,
  setDateRange,
  expanded = true,
}) => {
  return (
    <Collapse in={expanded}>
      <Box
        sx={{
          mb: 2,
          mt: 3,
          px: { xs: 0, sm: 1 },
        }}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          alignItems={{ xs: "stretch", sm: "flex-end" }}>
          {/* <StatusDropdown value={statusFilter} onChange={setStatusFilter} /> */}
          <DateInput
            label="From"
            value={dateRange.start}
            onChange={(val) =>
              setDateRange((prev) => ({ ...prev, start: val }))
            }
          />
          <DateInput
            label="To"
            value={dateRange.end}
            onChange={(val) => setDateRange((prev) => ({ ...prev, end: val }))}
          />
        </Stack>
      </Box>
    </Collapse>
  );
};

export default OrderFilters;
